import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { EventData } from '../../providers/event';
import { Database } from '../../providers/database';
import { BaseChartDirective } from 'ng2-charts/ng2-charts';

@Component({
  selector: 'page-event-opinometer-view',
  templateUrl: 'event-opinometer-view.html'
})

export class EventOpinometerView {
  @ViewChild(BaseChartDirective) chart: BaseChartDirective;

  obs: any;
  dataOpinometer: any;
  statsOpinometer: any;
  client: any;
  event: any;
  questionSelected = 0;
  labelsGenerate: any;

  // charts
  public chartOptions:any = {
    responsive: false
  };

  constructor(public navCtrl: NavController, public params: NavParams, public eventProvider: EventData, public db: Database) {
    this.client = this.params.get('client');
    this.event = this.params.get('event');

    this.obs = this.eventProvider.getOpinometerPublish(this.client, this.event.id).subscribe((result: any) => {
      this.obs = this.eventProvider.getOpinometerQuestions(this.client, result.$value).subscribe(result2 => {
        this.dataOpinometer = result2;
      });

      this.obs = this.eventProvider.getOpinometerStats(this.client, result.$value).subscribe(result3 => {
        this.statsOpinometer = result3;
      });
    });
  }

  getPercentage(item, index) {
    try {
      let value = this.getDataOpinometer(item.id)[0][index];

      if (value) {
        let sum = 0;
          this.getDataOpinometer(item.id)[0].forEach(subtotal => sum += subtotal);

          // return Math.trunc((value/sum) * 100);
          let op: any = (value/sum) * 100;
          return parseFloat(op).toFixed(2);
      }
    } catch(err) {
      return 0;
    }

    return 0;
  }

  getNumber(data) {
    return parseFloat(data).toFixed(2);
  }

  public setPieLabels(item: any) {
    if (this.labelsGenerate != item.id) {
      let labels = [];

      item.answers.forEach((element: any, key) => {
        labels.push(element.es);
      });

      if (this.chart && this.chart.chart && this.chart.chart.config) {
        setTimeout(() => {
          this.chart.chart.config.data.labels = labels;
          this.chart.chart.update();
          this.labelsGenerate = this.questionSelected;
        });
      }
    }
  }

  public getDataOpinometer(id) {
    let numbers = this.statsOpinometer.filter((x) => {return x.$key == id});

    return numbers;
  }

  closeListener() {
    if (this.obs) {
      console.log('Se eliminan los observables de proyector de opinómetros');
      this.obs.unsubscribe();
    }
  }

  // Unsubsucribe observables on exit page
  ngOnDestroy() {
    this.closeListener();
  }
}
// end file



// WEBPACK FOOTER //
// ./src/pages/event-opinometer-view/event-opinometer-view.ts